"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemErrorPopoverContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
function RedeemErrorPopoverContent({ title, description, onSubmit, CTAButtonText, }) {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { "data-e2e": 'RedeemErrorPopoverContent_Wrapper', children: [(0, jsx_runtime_1.jsx)(atoms_1.RedeemErrorPopoverTitle, { "data-e2e": 'RedeemErrorPopoverContent_RedeemErrorPopoverTitle', children: title }), (0, jsx_runtime_1.jsx)(atoms_1.RedeemErrorPopoverDescription, { "data-e2e": 'RedeemErrorPopoverContent_RedeemErrorPopoverDescription', children: description }), (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: onSubmit, "data-e2e": 'RedeemErrorPopoverContent_StyledPrimaryButton', children: CTAButtonText })] }));
}
exports.RedeemErrorPopoverContent = RedeemErrorPopoverContent;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 32px;

  gap: 32px;
`;
const StyledPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  text-transform: uppercase;
  color: ${({ theme }) => theme.background};
`;
